export default "__VITE_ASSET__ff0673b7__"